import { render, staticRenderFns } from "./GNumInput.vue?vue&type=template&id=2adf4dfc&"
import script from "./GNumInput.vue?vue&type=script&lang=js&"
export * from "./GNumInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports